export const TAGS_REDUCER_KEYS = {
  REDUCER: 'tags',
  PROJECT_TAGS_BY_NAME: 'projectTagsByName',
  ITEM_TAGS_BY_NAME: 'itemTagsByName',
}
